import { H1 } from "../../components/Text/Text";
import CreateNewMediaCompanyShortBody from "./CreateNewMediaCompanyShortBody";
import CreateNewMediaCompanyShortFooter from "./CreateNewMediaCompanyShortFooter";

import styles from "./createNewMediaCompanyShort.module.scss";

export default {
  header: <H1>Create new media company</H1>,
  body: <CreateNewMediaCompanyShortBody />,
  footer: <CreateNewMediaCompanyShortFooter />,
  className: styles.wrapper,
};

export const CreateNewMediaCompanyShortWithName = (mediaCompanyName: string) => ({
  header: <H1>Create new media company</H1>,
  body: <CreateNewMediaCompanyShortBody mediaCompanyName={mediaCompanyName} />,
  footer: <CreateNewMediaCompanyShortFooter />,
  className: styles.wrapper,
});
